import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

/**
 * BookingCancel — Stripe redirects here when the customer hits
 * "back" in the Checkout page. The booking row still has its
 * `stripe_checkout_session_id` set; the customer can create a new
 * session by hitting "Try again" on the confirmation step.
 */
export default function BookingCancel() {
  const [params] = useSearchParams();
  const bookingId = params.get("booking_id");

  return (
    <div className="bg-background">
      <main className="mx-auto max-w-2xl px-6 py-16 text-center" data-testid="booking-cancel">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-muted text-muted-foreground">
          <XCircle className="h-10 w-10" />
        </div>
        <h1 className="mt-6 font-heading text-4xl font-bold text-pp-text sm:text-5xl">
          Payment canceled
        </h1>
        <p className="mt-3 text-sm text-muted-foreground">
          No charge was made. Your booking is still saved — you can finish
          checkout any time.
        </p>
        <div className="mt-8 flex justify-center gap-3">
          {bookingId ? (
            <Link to={`/book/confirmation/${bookingId}`}>
              <Button
                data-testid="booking-cancel-retry-btn"
                className="rounded-full bg-pp-orange text-pp-cta-text hover:bg-pp-orange-hover"
              >
                Try again
              </Button>
            </Link>
          ) : (
            <Link to="/book">
              <Button
                data-testid="booking-cancel-rebook-btn"
                className="rounded-full bg-pp-orange text-pp-cta-text hover:bg-pp-orange-hover"
              >
                Start a new booking
              </Button>
            </Link>
          )}
          <Link to="/dashboard/customer">
            <Button data-testid="booking-cancel-dashboard-btn" variant="ghost" className="rounded-full">
              Back to dashboard
            </Button>
          </Link>
        </div>
      </main>
    </div>
  );
}
